import LegalLayout from "@/components/feature/LegalLayout";
import Seo from "@/components/feature/Seo";
import { buildBreadcrumbSchema } from "@/seo/schema";
import { SITE_URL } from "@/pages/home/constants";

const PAGE_URL = `${SITE_URL}termos-de-uso`;

export default function TermsOfUse() {
  return (
    <>
      <Seo
        title="Termos de Uso | Eco Tour Turismo Capitólio"
        description="Reserve com tranquilidade: confira as condições de reserva, pagamento, segurança a bordo e cancelamento dos passeios de lancha em Capitólio, MG."
        keywords="termos de uso, reserva passeio de lancha Capitólio, Eco Tour Turismo"
        canonical={PAGE_URL}
        jsonLd={buildBreadcrumbSchema([
          { name: "Início", url: SITE_URL },
          { name: "Termos de Uso", url: PAGE_URL },
        ])}
      />
      <LegalLayout title="Termos de Uso" updatedAt="Outubro de 2026">
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">1. Aceitação dos termos</h2>
          <p>
            Ao navegar neste site e contratar os passeios da Eco Tour Turismo, você concorda com os termos
            descritos nesta página. Recomendamos a leitura atenta antes de realizar qualquer reserva.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">2. Reservas e pagamentos</h2>
          <p>
            As reservas são confirmadas por meio dos nossos canais de atendimento, especialmente pelo
            WhatsApp. As condições de pagamento, valores e políticas de cancelamento são informadas
            diretamente pela nossa equipe no momento da reserva.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">3. Segurança a bordo</h2>
          <p>
            Todos os passeios seguem as normas de segurança da Marinha e contam com equipamentos de
            salvamento. É obrigatório o uso de coletes salva-vidas durante a navegação, conforme orientação da
            tripulação.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">4. Condições climáticas</h2>
          <p>
            Os passeios podem ser remarcados ou cancelados em caso de condições climáticas desfavoráveis, por
            questões de segurança. Nesses casos, oferecemos a possibilidade de reagendamento sem custo
            adicional.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">5. Responsabilidades</h2>
          <p>
            A Eco Tour Turismo se compromete a oferecer um serviço seguro e de qualidade. O cliente é
            responsável por seguir as orientações da tripulação e por informar condições de saúde relevantes
            antes do embarque.
          </p>
        </section>
      </LegalLayout>
    </>
  );
}